import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicBackgroundComponent } from './public-background/public-background.component';
import { SharedServicesModule } from '../shared-services/shared-services.module';
import { LayoutComponent } from './layout/layout.component';
import { CoreModule } from '../core/core.module';
import { VendorModule } from '../core/vendor.module';
import { NotificationsComponent } from './notifications/notifications.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { EmptyListPatternComponent } from './empty-list-pattern/empty-list-pattern.component';
import { SidenavComunicationService } from './layout/sidenav-comunication.service';
import { SearchInputComponent } from './search-input/search-input.component';
import { GenericFiltersComponent } from './generic-filters/generic-filters.component';
import { OverlayComponent } from './overlay/overlay.component';
import { BackButtonComponent } from './back-button/back-button.component';
import { ExpansorWithChipComponent } from './expansor-with-chip/expansor-with-chip.component';
import { ModalConfirmDialogComponent } from './modals/modal-confirm-dialog.component';
import { ModalMessageDialogComponent } from './modals/modal-message-dialog.component';
import { ModalInputDialogComponent } from './modals/modal-input-dialog.component';
import { ModalChecklistDialogComponent } from './modals/modal-checklist-dialog.component';
import { DialogService } from './modals/dialog.service';
import { GenericListComponent } from './generic-list/generic-list.component';
import { SelectOverviewComponent } from './select-overview/select-overview.component';
import { ExpansorWithChipMultipleComponent } from './expansor-with-chip-multiple/expansor-with-chip-multiple.component';
import { CompleteMontoCompraComponent } from './complete-monto-compra/complete-monto-compra.component';
import { UsuarioDatosAdministrativosComponent } from './usuario-datos-administrativos/usuario-datos-administrativos.component';
import { UsuarioDatosPersonalesComponent } from './usuario-datos-personales/usuario-datos-personales.component';
import { UsuarioDatosDireccionesComponent } from './usuario-datos-direcciones/usuario-datos-direcciones.component';
import { UsuarioDatosCuentaComponent } from './usuario-datos-cuenta/usuario-datos-cuenta.component';
import { UsuarioDatosContactoComponent } from './usuario-datos-contacto/usuario-datos-contacto.component';
import { UsuarioPhoneListComponent } from './usuario-phone-list/usuario-phone-list.component';
import { UsuarioEmailListComponent } from './usuario-email-list/usuario-email-list.component';
import { UsuarioDatosDocumentacionComponent } from './usuario-datos-documentacion/usuario-datos-documentacion.component';
import { CovalentFileModule } from '@covalent/core';
import { SaldoMonedaComponent } from './saldo-moneda/saldo-moneda.component';
import { CompleteCambioEmailComponent } from './complete-cambio-email/complete-cambio-email.component';
import { ValidarDocumentacionComponent } from './validar-documentacion/validar-documentacion.component';
import { AprobacionClienteResolver } from './validar-documentacion/aprobacionCliente.resolver';
import { UsuarioDatosUbicacionCardComponent } from './usuario-datos-ubicacion-card/usuario-datos-ubicacion-card.component';
import { UsuarioDatosPersonalesCardComponent } from './usuario-datos-personales-card/usuario-datos-personales-card.component';
import { SelectMotivoRechazoComponent } from './select-motivo-rechazo/select-motivo-rechazo.component';
import { CambioSpreadComponent } from '../shared-components/cambio-spread/cambio-spread.component';
import { CambioDolarCompraComponent } from '../shared-components/cambio-dolar-compra/cambio-dolar-compra.component';
import { CambioDolarVentaComponent } from '../shared-components/cambio-dolar-venta/cambio-dolar-venta.component';
import { UsuarioPanelDocumentacionComponent } from './usuario-panel-documentacion/usuario-panel-documentacion.component';
import { ModalLinkConfirmacionComponent } from './modals/link-confirmacion/modal-link-confirmacion.component';
import { ChipAutocompleteComponent } from './chip-autocomplete/chip-autocomplete.component';
import { ChipListAutocompleteComponent } from './chip-list-autocomplete/chip-list-autocomplete.component';
import { ExpansorWithSearchComponent } from './expansor-with-search/expansor-with-search.component';
import { ExpansorWithSearchDateComponent } from './expansor-with-search-date/expansor-with-search-date.component';
import { ExpansorWithSearchTextComponent } from './expansor-with-search-text/expansor-with-search-text.component';
import { ModalImageDialogComponent } from './modals/modal-image-dialog.component';
import { ConfiguracionModule } from '../configuracion/configuracion.module';
import { UsuarioClienteResolver } from '../cliente/cliente-user-add-edit/usuario-cliente.resolver';
import { ModalImageSliderDialogComponent } from './modals/modal-image-slider-dialog.component';
import { SlideshowModule } from 'ng-simple-slideshow';
import { ReplaceComa } from './replaceComa.pipe';
import { ModalModificacionCostosEnvioMasivoComponent } from './modals/modificacion-costos-envio/modal-modificacion-costos-envio-masivo/modal-modificacion-costos-envio-masivo.component';

const components = [
  PublicBackgroundComponent,
  LayoutComponent,
  NotificationsComponent,
  PaginatorComponent,
  EmptyListPatternComponent,
  SearchInputComponent,
  GenericFiltersComponent,
  OverlayComponent,
  BackButtonComponent,
  ExpansorWithChipComponent,
  ExpansorWithChipMultipleComponent,
  CambioSpreadComponent,
  CambioDolarCompraComponent,
  CambioDolarVentaComponent,
  CompleteMontoCompraComponent,
  CompleteCambioEmailComponent,
  UsuarioDatosAdministrativosComponent,
  UsuarioDatosPersonalesComponent,
  UsuarioDatosDireccionesComponent,
  UsuarioDatosCuentaComponent,
  UsuarioDatosContactoComponent,
  UsuarioPhoneListComponent,
  UsuarioEmailListComponent,
  UsuarioDatosDocumentacionComponent,
  SaldoMonedaComponent,
  ModalConfirmDialogComponent,
  ModalMessageDialogComponent,
  ModalInputDialogComponent,
  ModalChecklistDialogComponent,
  ModalImageDialogComponent,
  ModalImageSliderDialogComponent,
  GenericListComponent,
  SelectOverviewComponent,
  ValidarDocumentacionComponent,
  UsuarioDatosUbicacionCardComponent,
  UsuarioDatosPersonalesCardComponent,
  SelectMotivoRechazoComponent,
  UsuarioPanelDocumentacionComponent,
  ModalLinkConfirmacionComponent,
  ChipAutocompleteComponent,
  ChipListAutocompleteComponent,
  ExpansorWithSearchComponent,
  ExpansorWithSearchDateComponent,
  ExpansorWithSearchTextComponent,
  ReplaceComa,
  ModalModificacionCostosEnvioMasivoComponent
];

@NgModule({
  imports: [
    CommonModule,
    SharedServicesModule,
    CoreModule,
    VendorModule,
    CovalentFileModule,
    SlideshowModule,
  ],
  declarations: components,
  exports: components,
  providers: [
    SidenavComunicationService,
    DialogService,
    AprobacionClienteResolver,
    UsuarioClienteResolver
  ],
  entryComponents: [
    ModalConfirmDialogComponent,
    ModalMessageDialogComponent,
    ModalInputDialogComponent,
    ModalChecklistDialogComponent,
    ModalLinkConfirmacionComponent,
    ModalImageDialogComponent,
    ModalImageSliderDialogComponent,
    ModalModificacionCostosEnvioMasivoComponent
  ],
})
export class SharedComponentsModule { }



// WEBPACK FOOTER //
// ./src/app/shared-components/shared-components.module.ts